import classNames from 'classnames';
import {
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function Information({
  className = '',
  value = '',
  disableInput = false,
  onUpdate = () => {},
}) {
  /**
   * When a field is changed
   */
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  return (
    <Grid className={classNames('Information', className)} spacing={2} container>
      <Grid size={12}>
        <Field
          type="text"
          label="Name"
          name="value"
          placeholder="Name"
          value={value}
          disabled={disableInput}
          tabIndex={10}
          onChange={onChange}
          autoFocus
          required
        />
      </Grid>
    </Grid>
  );
}

export default Information;
